import styled from 'styled-components';

import { InteractiveTable } from '@dreryk/react-components';

export const StyledEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable = styled(
   InteractiveTable
)`
   width: 520px;
` as typeof InteractiveTable;
